import React from "react";
import WidgetContainer from "../../components/WidgetComponents/WidgetContainer/WidgetContainer";
import { parseWidgetConfig } from "../../utils/widgetConfig";
import { mergeTheme } from "../../utils/theme";
import "../../styles/widget-reset.css";

const Widget = () => {
  const config = parseWidgetConfig();
  const theme = mergeTheme(config.theme);

  return (
    <WidgetContainer
      apiKey={config.apiKey}
      apiUrl={config.apiUrl}
      theme={theme}
    />
  );
};

export default Widget;
